import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class ViewApplicationDetailsWamsConstants {
    static STEP_TITLE = "Details";
    static DESCRIPTION_LABEL = "Description";
    static APPLICATION_TYPE_LABEL = "Application type";
    static CLIENT_REFERENCE_NUMBER_LABEL = "Client reference number";
    static APPLICANT_TELECOMMUNICATION_LICENCE_NUMBER_LABEL = "Applicant Telecommunication License Number";
    static SCOPE_OF_WORK_LABEL = "Scope of work";
    static ESTIMATED_CONSTRUCTION_COST_LABEL = "Estimated construction cost (R) (incl. vat)";
    static APPLICATION_FEE_LABEL = "Application fee (R) (incl. vat)";
    static PROPOSED_START_DATE_LABEL = "Proposed start date";
    static PROPOSED_END_DATE_LABEL = "Proposed end date ";
    static LANE_CLOSURE_IS_REQUIRED_LABEL = "Lane closure is required";
    static LANE_CLOSURE_EXTENT_LABEL = "Lane closure extent";
    static CONSTRUCTION_PERIOD_UNITS_LABEL = "Construction period units";
    static SERVICES_LABEL = "Services";
    static CONSTRUCTION_PERIOD_LABEL = "Construction period";
    static ELECTRICAL_SERVICES_LABEL = "Electrical services";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static APPLICATION_TYPE_FORM_CONTROL_NAME = "applicationType";
    static CLIENT_REFERENCE_NUMBER_FORM_CONTROL_NAME = "clientReferenceNumber";
    static APPLICANT_TELECOMMUNICATION_LICENCE_NUMBER_FORM_CONTROL_NAME = "applicantTelecommunicationLicenseNumber";
    static SCOPE_OF_WORK_FORM_CONTROL_NAME = "scopeOfWork";
    static ESTIMATED_CONSTRUCTION_COST_FORM_CONTROL_NAME = "estimatedConstructionCost";
    static APPLICATION_FEE_FORM_CONTROL_NAME = "applicationFee";
    static PROPOSED_START_DATE_FORM_CONTROL_NAME = "proposedStartDate";
    static PROPOSED_END_DATE_FORM_CONTROL_NAME = "proposedEndDate";
    static LANE_CLOSURE_IS_REQUIRED_FORM_CONTROL_NAME = "laneClosureIsRequired";
    static LANE_CLOSURE_EXTENT_FORM_CONTROL_NAME = "laneClosureExtent";
    static CONSTRUCTION_PERIOD_UNITS_FORM_CONTROL_NAME = "constructionPeriodUnits";
    static ELECTRICAL_SERVICES_FORM_CONTROL_NAME = "electricalServices";
    static SERVICES_FORM_CONTROL_NAME = "services";
    static CONSTRUCTION_PERIOD_FORM_CONTROL_NAME = "constructionPeriod";
    static DATE_VALIDATION_ERROR = "The proposed start date needs to be less than or equal to the proposed end date";
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        clientReferenceNumber: {
            required: `Client reference number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        applicantTelecommunicationLicenseNumber: {
            required: `Applicant telecommunication license number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        scopeOfWork: {
            required: `Scope of work ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        estimatedConstructionCost: {
            required: `Estimated construction cost ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        applicationFee: {
            required: `Application fee ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        proposedStartDate: {
            required: `Proposed start date ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        proposedEndDate: {
            required: `Proposed end date ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        laneClosureIsRequired: {
            required: `Lane closure is required ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        laneClosureExtent: {
            required: `Lane closure extent ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        constructionPeriodInWeeks: {
            required: `Construction period in weeks ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        electricalServices: {
            required: `Electrical services ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
